import React from "react";
import Group from "../../Assets/Group.png";

function Aboutcompany() {
  return (
    <section className="bg-gradient-to-r from-gray-800 to-gray-900 text-white py-10">
      <div className="container flex flex-col  lg:flex-row items-center gap-8 justify-between mx-auto max-w-6xl px-4">
        <div className="flex items-center  justify-center w-full lg:w-1/2 mb-8 lg:mb-0">
          <div className="rounded-md  shadow-md overflow-hidden w-3/4 sm:w-1/2 lg:w-3/4 xl:w-full">
            <img
              src={Group}
              alt="Company Icon"
              className="w-full h-1/3 object-cover md:h-1/3"
            />
          </div>
        </div>

        <div className="text-white lg:w-1/2 text-center lg:text-left px-4">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">ABOUT COMPANY</h2>
          <p className="text-sm md:text-base mb-4">
            Everyday practice shows that the constant information and propaganda
            support of our activities plays an important role in shaping the
            personnel training system and meets urgent needs.
          </p>
          <p className="text-sm md:text-base mb-6">
            Everyday practice shows that the constant information and propaganda
            support of our activities plays an important role in shaping the
            personnel training system and meets urgent needs.
          </p>
          <button className="bg-blue-500 text-white py-2 px-6 rounded hover:bg-blue-600 transition">
            Get Started
          </button>
        </div>
      </div>
    </section>
  );
}

export default Aboutcompany;
